import React from "react";
// Common Components
import OrderBookTable from "../OrderBookTable";
// Hooks
import useRequest from "src/Hooks/useRequest";
// Requests
import { getPairPositionOrderbook } from "src/Requests/iMEMarketWatch";
// Types
import type {
  ISelectedPairTableInfo,
  IOrderbookPairResp,
  IOrderbooksBody,
} from "src/Interfaces/iMEMarketWatch";

interface IProps {
  selectedTableInfo: ISelectedPairTableInfo | null;
}

const Orderbook: React.FC<IProps> = ({ selectedTableInfo }) => {
  const orderBookRequest = useRequest(
    () =>
      getPairPositionOrderbook(
        selectedTableInfo?.firstContractCode || "",
        selectedTableInfo?.secondContractCode || "",
      ),

    () => {},
  );

  React.useEffect(() => {
    if (!selectedTableInfo) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, 4000);

    return () => clearInterval(interval);
  }, [selectedTableInfo]);

  const getOrderbookValues = (
    values?: IOrderbooksBody[],
  ): IOrderbooksBody[] => {
    if (!values || !values.length) return new Array(2).fill(null as any);

    if (values.length < 2) {
      const res: IOrderbooksBody[] = [...values];
      for (let index = 0; index < 2 - values.length; index++) {
        res.push(null as any);
      }
      return res;
    }
    return values;
  };

  return (
    <div className="flex flex-row justify-start items-end pt-5">
      {getOrderbookValues(orderBookRequest?.response?.orderBooks)?.map(
        (resp: any) => (
          <div className="mx-0.5">
            <OrderBookTable tableInfo={resp?.fullOrderBook} logo="ime" />
          </div>
        ),
      )}
    </div>
  );
};

export default Orderbook;
